/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { sdsIconDefaults, SdsIconProps } from './SdsIcon.props';

/**
 * SDS Icon component.
 */
export const SdsIcon = (props: SdsIconProps): JSX.Element => {
  const { classes, customTag, svg } = {
    ...sdsIconDefaults,
    ...props,
  };

  const CustomTag = customTag as keyof JSX.IntrinsicElements;
  const wrapperClass = clsx(`svg-wrapper`, classes);

  return <CustomTag className={wrapperClass}>{svg}</CustomTag>;
};
